export enum EmissionFactorCalculationMethod {
  Calculated = 'calculated',
  ImportedGrid = 'importedGrid',
}
